import {useRef, useState, useImperativeHandle, forwardRef, createElement} from 'react'
import { useDialog } from '../DialogProvider'
import { useLang } from '../LangProvider'
import { useAuth } from '../AuthProvider'
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
// import React from "@types/react";

const SignUp = forwardRef(( props, ref ) => {

  useImperativeHandle(ref, () => ({
    openDialog(query) {
      handleClose()
      console.log("signup dialog opened from provider with",query)
      handleOpenDialog()

      console.log('sign up query',query)
      setEvent(query.event)
      setRace(query.race)

    }
  }) )

  const [dialogState,setDialogState] = useState(false)
  const [event,setEvent] = useState({})
  const [race,setRace] = useState({})
  const [regSelf, setRegSelf] = useState(true)
  const [xpayIframe, setXpayIframe] = useState(<></>)
  const closeDialog = useDialog()
  const refIframe = useRef(null),
        refForm = useRef(null),
        dialogRef = useRef(null)
  const {lang, t} = useLang()
  const {auth} = useAuth()

  // fields refs
  const refSos = useRef(null),
        refEmail = useRef(null),
        // refPayed = useRef(null),
        refPhone = useRef(null),
        refPrice = useRef(null),
        refPromo = useRef(null),
        // refAge = useRef(null),
        refGender = useRef(null),
        refShirtSize = useRef(null),
        refMerchandise = useRef(null),
        // refAgeCategory = useRef(null),
        refBirthDate = useRef(null),
        // refUserId = useRef(null),
        refRegisterSelf = useRef(null),
        // refRegistrarId = useRef(null),
        refTime = useRef(null),
        refFirstName = useRef(null),
        refLastName = useRef(null),
        refCity = useRef(null),
        refClub = useRef(null)

  const pattern = {
    username: `.{3,}`,
    firstname:`.{2,}`,
    lastname:`.{3,}`,
    mail:`^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)`,
    telephone:`[+]{0,1}[0-9 \\-]{10,}`,
    birthDate:``,
    city:`.{3,}`,
    club:`.{3,}`,
    emergencyContacts:`.{20,}`,
  }

  function handleClose(e = undefined){
    console.log("closing because: ",e)
    if (e !== undefined && e.type !== "click" && e.key !== "Escape") return null
    dialogRef.current.setAttribute("open", false)
    dialogRef.current.close()
    setDialogState(false)
    closeDialog('')
  }

  function handleOpenDialog(){
    setDialogState(true)
    dialogRef.current.removeAttribute("open");
    dialogRef.current.showModal();
  }

  function handleFormSubmit(e) {
    if (e) e.preventDefault()
    // toast.warn("Query payment for event signing up ...",{
    //   position: "top-center",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: true,
    //   progress: undefined,
    //   theme: "colored",
    //   containerId:"app"
    // })

    let self = refRegisterSelf.current.checked // also available as state


    if (self) {
      // register self

      let planned_time = refTime.current.value

      console.log('planned time',planned_time)

      let data = new FormData()
      data.append("race_id", race.id)
      data.append("self", (regSelf ? 1 : 0))

      data.append("planned_time", "00:00:00")


      axios({
        method: "post",
        url: process.env.REACT_APP_BACKEND_RACE_REGISTER,
        data: data,
        headers: {
          "Content-type": "multipart/form-data; charset=UTF-8",
          "Authorization": "Bearer " + auth.token
        }
      })
        .then(res => {
          if (res.data.hasErrors) {
            for (const [key, value] of Object.entries(res.data.errors)) {
              toast.error(value['0'], {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
                containerId: "dialog-signup"
              })
            }
            //setResponse('reg error')
            console.log('reg error:', res)
            handleClose()
          } else {
            console.log('signed up with', data, res)
            if (res.data.need_payment) {
              handlePayment(res.data.payment_link)
            }else{
              alert('no payment needed, thaks for registration!')
            }
          }
        })
        .catch((err) => {
          console.log("sign up error", err)
          if (err.response.data.status === 200) {
            err.response.data.participant.forEach( (value) =>  {
              console.log(value)
              toast.error(value.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
                containerId: "dialog-signup"
              })
            })
            if (err.response.data.need_payment) {
              handlePayment(err.response.data.payment_link)
            }else{
              alert('no payment needed, thaks for registration!')
            }
          }
        })

    } else {
      // register other

      let planned_time = refTime.current,
          sos = refSos.current,
          email = refEmail.current,
          phone = refPhone.current,
          promo = refPromo.current,
          gender = refGender.current,
          shirt_size = refShirtSize.current,
          merchandise = refMerchandise.current,
          birthday = refBirthDate.current,
          first_name = refFirstName.current,
          last_name = refLastName.current,
          city = refCity.current,
          club = refClub.current

      if (!(first_name.validity.valid ||
        email.validity.valid ||
        phone.validity.valid ||
        last_name.validity.valid ||
        sos.validity.valid ||
        email.validity.valid ))
      {
        console.log('register other failed')
        toast.warn(lang['dialog signup check data'],{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"dialog-signup"
        })
        return null;
      }

      console.log('planned time',planned_time)

      let data = new FormData()
      data.append("race_id", race.id)
      data.append("self", (regSelf ? 1 : 0))

      data.append("planned_time", "00:00:00")


      axios({
        method: "post",
        url: process.env.REACT_APP_BACKEND_RACE_REGISTER,
        data: data,
        headers: {
          "Content-type": "multipart/form-data; charset=UTF-8",
          "Authorization": "Bearer " + auth.token
        }
      })
        .then(res => {
          if (res.data.hasErrors) {
            for (const [key, value] of Object.entries(res.data.errors)) {
              toast.error(value['0'], {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
                containerId: "dialog-signup"
              })
            }
            //setResponse('reg error')
            console.log('reg error:', res)
            handleClose()
          } else {
            console.log('signed up with', data, res)
            if (res.data.need_payment) {
              handlePayment(res.data.payment_link)
            }else{
              alert('no payment needed, thaks for registration!')
            }
          }
        })
        .catch((err) => {
          console.log("sign up error", err)
          if (err.response.data.status === 200) {
            err.response.data.participant.forEach( (value) =>  {
              console.log(value)
              toast.error(value.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
                containerId: "dialog-signup"
              })
            })
            if (err.response.data.need_payment) {
              handlePayment(err.response.data.payment_link)
            }else{
              alert('no payment needed, thaks for registration!')
            }
          }
        })

    }
 }

  function handlePayment(link){
    console.log('handlePayment',refIframe)
    refForm.current.classList.toggle('inactive')
    setXpayIframe(
      <>
        <iframe
          id = {'xpay'}
          name = {'xpay'}
          src = {link}
        />
        <button className="button-teal" onClick={() => handleReset()}>{lang['dialog payment abort']}</button>
      </>)
    window.addEventListener("message", paymentListener);
  }

  function paymentListener(e){
    console.warn('event listened: ',e);
    if(e.data?.event_id === "close"){
      // remove iframe and show thanks
      setXpayIframe(<>
        <h3>{lang['dialog payment success header']}</h3>
        <button className="button-teal" onClick={() => handleClose()}>{lang['dialog payment success button close']}</button>
      </>)
      removePaymentListener();
    }
  }

  function removePaymentListener(){
    console.log('removing listener')
    window.removeEventListener("message", paymentListener)
  }

  function handleReset(){
    removePaymentListener()
    setXpayIframe(<></>)
    refForm.current.classList.toggle('inactive')
  }

  const Ranges = (input_data) => {
    if (typeof input_data === "undefined") return null
    let data = JSON.parse(input_data)
    if (data.length === 0) return null
    let options = []

    for (const [gender, ageRanges] of Object.entries(data)) {
      for (const ageRange of ageRanges) {
        options.push(
          <option key={options.length} value={ageRange.name}>{ageRange.name}</option>
        )
      }
    }

    return options
  }

  return <dialog className={"dialog-signup" + (!dialogState ? ' hidden' : '')} open={dialogState} ref={dialogRef} onKeyDown={e => handleClose(e)}>

    <form ref={refForm} onSubmit={() => handleFormSubmit()} className={regSelf ? "signup-self" : "signup-other"}>
      <h2>{lang['signup title']}</h2>
      <h1>{t(event.name)}</h1>
      <h2>{t(race.name)}</h2>
      <label htmlFor="signup-self" className="dialog-policies">
        <span>{lang["dialog register self"]}</span>
        <input type="checkbox" id="signup-self" checked={regSelf} onClick={() => setRegSelf(!regSelf)} ref={refRegisterSelf}/>
      </label>
      <marquee className={'dialog-signup--note-for-reg-other'}
               behavior="alternate">{lang['dialog signup note reg other']}</marquee>

      <label for="signup-promo" className="dialog-signup--other">
        <span>{lang['dialog signup promocode']}</span>
        <input type="text"
               id="signup-promo"
               name="promocode"
               ref={refPromo}/>
      </label>

      <label htmlFor="signup-first-name" className="dialog-signup--other">
        <span>{lang['dialog signup first name']}</span>
        <input type="text"
               id="signup-first-name"
               name="firstName"
               pattern={pattern.firstname}
               ref={refFirstName}
               required/>
      </label>

      <label htmlFor="signup-last-name" className="dialog-signup--other">
        <span>{lang['dialog signup last name']}</span>
        <input type="text"
               id="signup-first-name"
               name="lastName"
               pattern={pattern.lastname}
               ref={refLastName}
               required/>
      </label>

      <label htmlFor="signup-city">
        <span>{lang['dialog signup city']}</span>
        <input type="text"
               id="signup-city"
               name="city"
               pattern={pattern.city}
               ref={refCity}/>
      </label>

      <label htmlFor="signup-club" className="dialog-signup--other">
        <span>{lang['dialog signup club']}</span>
        <input type="text"
               id="signup-club"
               name="club"
               pattern={pattern.club}
               ref={refClub}/>
      </label>

      <label htmlFor="signup-time">
        <span>{lang['dialog signup time']}</span>
        {/* TODO : use masked text field ? */}
        <input type="time"
               id="signup-time"
               name="planned_time"
               ref={refTime}
               min={"00:00"}
               max={"11:59"}
               step="1"
               defaultValue="00:01:00"/>
      </label>

      <label for="signup-phone" className="dialog-signup--other">
        <span>{lang["dialog telephone"]}</span>
        <input type="telephone"
               id="signup-phone"
               pattern={pattern.telephone}
               ref={refPhone}
               required/>
      </label>

      <label htmlFor="signup-email" className="dialog-signup--other">
        <span>{lang["dialog mail"]}</span>
        <input type="email"
               id="signup-email"
               pattern={pattern.mail}
               ref={refEmail}
               required/>
      </label>

      <label htmlFor="signup-birthdate" className="dialog-signup--other">
        <span>{lang["dialog date of birth"]}</span>
        <input type="date" id="signup-birthdate" ref={refBirthDate}/>
      </label>

      {/*<label htmlFor="signup-age" className="dialog-signup--other">*/}
      {/*  <span>{lang["dialog age"]}</span>*/}
      {/*  /!**/}
      {/*      TODO : birthdate to full years as plaseholder for refAge*/}
      {/*      is it required ?*/}
      {/*  *!/*/}
      {/*  <input type="number" id="signup-age" ref={refAge}/>*/}
      {/*</label>*/}

      {/*<label htmlFor="signup-agecategory">*/}
      {/*  <span>{lang["dialog age category"]}</span>*/}
      {/*  /!* TODO : select cat based on refAge *!/*/}
      {/*  <select ref={refAgeCategory}>*/}
      {/*    {Ranges(race.years_range)}*/}
      {/*  </select>*/}
      {/*</label>*/}

      <label htmlFor="signup-gender" className="dialog-signup--other">
        <span>{lang["dialog sex"]}</span>
        <select id="signup-gender" ref={refGender} required>
          <option value="" default disabled={true} selected>{lang['dialog signup option select gender']}</option>
          <option value="1">M</option>
          <option value="2">F</option>
        </select>
      </label>

      <label htmlFor="signup-shirt_size" className="dialog-signup--other">
        <span>{lang["dialog shirt size"]}</span>
        <select id="signup-shirt_size" ref={refShirtSize} required>
          <option value="" default disabled={true} selected>{lang['dialog signup option select shirt size']}</option>
          <option value="XS">XS</option>
          <option value="S">SL</option>
          <option value="M">M</option>
          <option value="L">L</option>
          <option value="XL">XL</option>
          <option value="XXL">XXL</option>
        </select>
      </label>

      <label htmlFor="signup-price_final">
        <span>{lang["dialog price final"]}</span>
        <input type="number" id="signup-price_final" value={race.price} disabled ref={refPrice}/>
      </label>

      <label htmlFor="signup-merchandise">
        <span>{lang["dialog merchandise"]}</span>
        <input type="text" id="signup-merchandise" value={race.available_merchandise} disabled ref={refMerchandise}/>
      </label>

      <label htmlFor="signup-sos_contact" className="dialog-signup--other">
        <span>{lang["dialog emergency contacts"]}</span>
        <input type="text"
               id="signup-sos_contact"
               pattern={pattern.emergencyContacts}
               ref={refSos}
               required/>
      </label>

      {/*<label htmlFor="signup-user_id">*/}
      {/*  <span>{lang["dialog username"]}</span>*/}
      {/*  <input type="number" id="signup-user_id" ref={refUserId}/>*/}
      {/*</label>*/}

      {/*<label htmlFor="signup-registrar_id">*/}
      {/*  <span>{lang["dialog registrar username"]}</span>*/}
      {/*  <input type="number" id="signup-registrar_id" ref={refRegistrarId}/>*/}
      {/*</label>*/}

      <div className="dialog-buttons">
        <button className="button-teal" type="reset" onClick={(e) => handleClose(e)}>{lang['dialog cancel']}</button>
        <button className="button-red" onClick={(e) => handleFormSubmit(e)}>{lang['dialog continue']}</button>
      </div>
    </form>

    <div className="xpay-container" ref={refIframe}>{xpayIframe}</div>

    <ToastContainer enableMultiContainer containerId={'dialog-signup'}/>

  </dialog>
  
})

export default SignUp